// addPeriodToTestss.js
import moment from 'moment';
import 'moment/locale/nb';
import {updateObject} from 'utils/reducerUtils';

// If possible, we should also set this once in app bootstrap:
// moment.locale('nb');

const parseNbMoment = (v) => {
	if (v == null || v === 'undefined' || v === 'null') return null;

	if (typeof v === 'number') {
		const m = v < 1e12 ? moment.unix(v) : moment(v);
		return m.isValid() ? m.locale('nb') : null;
	}

	let m = moment(v, moment.ISO_8601, true);
	if (!m.isValid()) m = moment(v).locale('nb');
	return m.isValid() ? m : null;
};

const addPeriodToTests = (row) => {
	const createdAt = parseNbMoment(row.createdAt);
	const distributedAt = parseNbMoment(row.distributedAt);
	const usedAt = row.isUsed ? parseNbMoment(row.usedAt) : null;
	const completedAt = parseNbMoment(row.completedAt);

	const groupAt =
		distributedAt ||
		usedAt ||
		completedAt ||
		createdAt ||
		moment().locale('nb');

	const safeCreatedAt = createdAt || groupAt;

	return updateObject(row, {
		createdAt: safeCreatedAt,
		distributedAt,
		usedAt,
		completedAt,
		groupAt,
	});
};

export default function addPeriodToTestss(rows) {
	return rows.map(addPeriodToTests);
}
